export interface ServerConfig {
  mainServerUrl: string;
  gameServerUrl?: string;
}

// Localhost fallback is for local dev only. In a production build
// `import.meta.env.DEV` is statically false, so esbuild folds this to '' and the
// localhost literal is stripped from the bundle entirely — a prod build can never
// silently fall back to localhost, and the deploy guard can treat any local URL
// in dist as a real leak.
const DEFAULT_MAIN_SERVER_URL = import.meta.env.DEV ? 'http://localhost:30086' : '';

export const serverConfig: ServerConfig = {
  mainServerUrl: import.meta.env.VITE_MAIN_SERVER_URL ?? DEFAULT_MAIN_SERVER_URL,
  gameServerUrl: import.meta.env.VITE_GAME_SERVER_URL,
};
